import { useCallback, useEffect } from "react"
import { useRef } from "react"
import { useState } from "react"
import ReactJson from 'react-json-view'
import { BiArrowBack, BiX } from "react-icons/bi";
import Lottie from "lottie-react";
import chat from "./../../assets/chat.json";
import gfm from 'remark-gfm'
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { AiOutlineAudio, AiOutlineAudioMuted, AiOutlineSend } from "react-icons/ai";
import debounce from 'lodash.debounce';
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { commonUtils } from '@centivo-business/utils'
import AIMessage from "./AIMessage";

const startAudio = new Audio('./../../assets/start.mp3');
const endAudio = new Audio('./../../assets/end.mp3');
const decoder = new TextDecoder();

const HrpGuideChatV1 = ({ }) => {
    const [threadId, setThreadId] = useState('')
    const [textInput, setTextInput] = useState('')
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false)
    const [isListening, setIsListening] = useState(false);
    const [messages, setMessages] = useState([
        //     {
        //     id: 1,
        //     content: 'hi how are you'
        // }
    ])
    const [errorMessage, setErrorMessage] = useState()
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;

    //benefitPlanName, benefitPlanComponents, 

    useEffect(() => {
        if (recognition) {

            recognition.InitialSilenceTimeout = 1000
            recognition.EndSilenceTimeout = 2000
            recognition.EndSilenceTimeoutAmbiguous = 2000
            recognition.continuous = false; // Listen for a single utterance
            recognition.interimResults = false; // Only return final results
            recognition.lang = 'en-US'; // Set language

            recognition.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setInputValue(transcript);
                setTextInput(transcript)
                setIsListening(false);
            };

            recognition.onerror = (event) => {
                console.error('Speech recognition error:', event.error);
                setIsListening(false);
            };

            recognition.onend = async () => {
                setIsListening(false);

                await endAudio.play();

            };
        }
    }, [recognition]);


    useEffect(() => {
        if (inputValue) {
            handleSubmit({ inputValue })
            setInputValue('')
            setTextInput('')
        }
    }, [inputValue])


    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]); // Dependency array: re-run effect when messages change


    const handleSubmit = async (e) => {
        e?.preventDefault?.()

        try {

            setLoading(true)
            setTextInput('')

            const content = e?.inputValue || textInput

            //  setMessages([{ id: crypto.randomUUID(), content: textInput }])
            setMessages(prev => ([...prev, { id: crypto.randomUUID(), content }]))

            //TODO add this in the code build env
            const url = import.meta.env.VITE_CHAT_FUNCTION_URL  //|| `https://eve4a6mda3ldgnbqyz45aojlca0zaqib.lambda-url.us-east-1.on.aws`;
            console.log({ url })

            const myHeaders = new Headers();
            myHeaders.append("x-api-key", "shhh");
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append('Accept', 'text/event-stream')
            const raw = JSON.stringify({
                message: content,
                threadId
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            const response = await fetch(url, requestOptions);
            if (!response.ok) {
                const errMsg = await response.json()
                setErrorMessage(errMsg.message)
                setLoading(false)
                return
            }
            for await (const chunk of response.body) {
                const decodedValue = decoder.decode(chunk, { stream: true });

                if (decodedValue) {
                    const lines = decodedValue.split('\n').filter(line => line.startsWith('data: '));

                    lines.forEach(line => {
                        const eventData = line.substring(5); // Remove "data: "
                        try {
                            const parsedEvent = JSON.parse(eventData);

                            if (parsedEvent.threadId !== threadId) setThreadId(parsedEvent.threadId)
                            setMessages(prev => ([...prev, { id: crypto.randomUUID(), ...parsedEvent }]))
                        } catch (err) {
                            console.error('Error parsing event data:', err);
                        }
                    });

                }

            }

            console.log("Stream finished.")


        } catch (err) {
            setErrorMessage(err.message)

        } finally {
            setLoading(false)
        }
        return


    }

    const startListening = async () => {

        await startAudio.play();
        await commonUtils.delay(200);
        if (recognition) {
            setIsListening(true);
            recognition.start();
        } else {
            alert('Speech Recognition not supported in this browser.');
        }
    };

    const disableSubmission = isListening || loading

    return (
        <div className="chat-container" style={{ flex: 1 }} >
            <>
                {/* <div style={{ width: "100px", paddingTop: "50%", margin: '0 auto', }}>
                    <Lottie
                        animationData={chat}
                        loop={true}
                        

                    />
                </div> */}
                {!messages?.length ? <>
                    <div className="chat-title"
                        style={!messages?.length ? {
                            display: 'grid',
                            // width: '100%',
                            // height: '100%',
                            flex: 1,
                            // height: '100%',
                            placeItems: 'center',

                        } : {}}>
                        <div style={{ textAlign: 'center' }}>
                            <p
                                style={!messages?.length ? {
                                    fontSize: '2rem',
                                    fontWeight: '600'
                                } : {}}> {'Hi '} </p>
                            <span style={{ fontSize: '1rem' }}>How can I help you?</span>
                        </div>



                    </div>
                </> : <>

                    {threadId && <div style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        backgroundColor: 'var(--lightestGrey)',
                        borderBottomRightRadius: '1rem',
                        borderBottomLeftRadius: '1rem',
                        // backdropFilter: 'blur(10px)',
                        padding: '1rem'
                    }}>
                        <p style={{ fontSize: '.8rem', fontWeight: '600' }}>Thread ID: {threadId}</p>
                        <p style={{ fontSize: '.8rem', color: 'var(--red)', cursor: 'pointer' }}
                            onClick={() => {
                                setMessages([])
                                setTextInput('')
                                setThreadId()
                            }}>Clear</p>

                    </div>}


                    <div className="chat-messages" >
                        {messages?.filter(msg => !msg?.output?.tool)?.filter(msg => !msg?.output?.tools)?.map(message => {
                            const aiMessage = message?.output?.model_request?.messages?.[0]?.kwargs;
                            const toolMessage = message?.output?.tool?.messages?.[0]?.kwargs;
                            const content = aiMessage?.content?.[0]?.text || aiMessage?.content

                            return <div className="chat-message-box" key={message.id} >
                                {/* {JSON.stringify(message.content)} */}
                                <div style={{ display: 'flex', alignItems: `center`, justifyContent: `${message?.content ? 'end' : 'start'}` }}>

                                    {/* <ReactJson
                                    src={message}
                                    name={false}
                                    collapsed={1}
                                    collapseStringsAfterLength={150}
                                    displayDataTypes={false}
                                    displayObjectSize={false} /> */}


                                    {message?.content && message?.content?.trim()?.length && <p style={{
                                        marginBottom: "0.5rem",
                                        whiteSpace: "pre-line",
                                        backgroundColor: 'var(--lightestBlue)',
                                        color: 'var(--black)',
                                        padding: '.6rem 1rem',
                                        borderRadius: '1rem',
                                        textAlign: 'right',
                                        width: 'fit-content',
                                        alignSelf: 'end',
                                        maxWidth: '80%',
                                        marginRight: 0
                                    }}>{message?.content}</p>}

                                    <AIMessage content={content} />
                                    {/* {aiMessage?.content?.[0].type === 'text' && <AIMessage content={aiMessage?.content?.[0]?.text} />}

                                {aiMessage?.response_metadata?.done || aiMessage?.response_metadata?.stopReason === 'end_turn' && <AIMessage content={aiMessage?.content} />
                                } */}



                                </div>
                            </div>
                        })}
                        <div ref={messagesEndRef} />
                    </div>



                </>}


            </>

            {
                loading ? <div style={{ padding: '1rem', display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'start' }}>
                    <div className="loader" ></div>
                </div> : <></>
            }


            {!messages.length && <div className="suggestions">
                <div className="suggestion">
                    <p onClick={() => handleSubmit({ inputValue: `Benefit Plan Wizard?` })}>Benefit Plan Wizard</p>
                </div>
                <div className="suggestion">
                    <p onClick={() => handleSubmit({ inputValue: `Claim types` })}>Claim types</p>
                </div>
                <div className="suggestion">
                    <p onClick={() => handleSubmit({ inputValue: `Billing Overview` })}>Billing Overview</p>
                </div>
            </div>}


            {errorMessage && <p className="danger" style={{ padding: '0rem 1rem' }}>{errorMessage}</p>}


            <div className="chat-input">

                <form onSubmit={handleSubmit}>
                    <input type="text" value={textInput} onChange={(e) => setTextInput(e.target.value)} disabled={disableSubmission} placeholder="Start typing..." />

                    {disableSubmission ? <AiOutlineAudioMuted size={'2rem'} color={'var(--lighterGrey)'} /> : <AiOutlineAudio onClick={startListening} size={'2rem'} />}
                    {/* <button onClick={startListening} disabled={isListening}>

                    </button> */}
                    {/* <input type="submit" value={''} disabled={loading} /> */}
                    <AiOutlineSend size={'2rem'} color={disableSubmission ? 'var(--lighterGrey)' : 'var(--black)'} onClick={() => !disableSubmission && handleSubmit()} />
                </form>

            </div>

        </div >
    )
}

export default HrpGuideChatV1